// "E — board the skiff". The one line that tells you the world will
// answer if you press something.
//
// It used to live inside the surface HUD, which is hidden indoors — so
// the moment a club had something worth walking up to, there was nowhere
// to say so. It is its own thing now, shown wherever you are.

export class WorldPrompt {
  private root: HTMLDivElement;
  private current: string | null = null;
  /**
   * While an answer is on screen, the standing offer does not overwrite
   * it. The game loop re-states the offer EVERY FRAME, so without this a
   * flashed answer lived for a single frame and the player saw nothing —
   * you could take a flyer and get no acknowledgement at all.
   */
  private flashUntil = 0;

  constructor(parent: HTMLElement) {
    this.root = document.createElement("div");
    this.root.className = "world-prompt";
    this.root.style.visibility = "hidden";
    parent.append(this.root);
  }

  /** Null hides it. Idempotent — safe to call every frame. */
  set(text: string | null): void {
    if (performance.now() < this.flashUntil) return;
    this.write(text);
  }

  private write(text: string | null): void {
    if (text === this.current) return;
    this.current = text;
    this.root.textContent = text ?? "";
    this.root.style.visibility = text ? "visible" : "hidden";
  }

  /**
   * Say something for a moment, then go back to whatever the world was
   * offering. For the ANSWER to pressing the key, not the offer itself —
   * so it outranks the offer for as long as it is up.
   */
  flash(text: string, ms = 3200): void {
    this.flashUntil = performance.now() + ms;
    this.write(text);
    window.setTimeout(() => {
      // Let the next frame restate whatever is on offer now.
      this.flashUntil = 0;
      this.write(null);
    }, ms);
  }
}
